import{setCookie as r,getCookie as s,deleteCookie as o}from"../../utils/cookieProvider.js";const t="lmsUser",l=e=>{try{return JSON.parse(e||"null")}catch{return null}},n={set:e=>r(t,JSON.stringify(e)),get:()=>l(s(t)),delete:()=>o(t)};export{n as lmsUserPersist};
//# sourceMappingURL=index.js.map
